import { StrKey } from 'stellar-sdk';
import { Buffer } from 'buffer';
import { Keyring } from '@polkadot/api';
export function stellarHexToPublic(hexString) {
    return StrKey.encodeEd25519PublicKey(hexToBuffer(hexString));
}
export function hexToBuffer(hexString) {
    if (hexString.length % 2 !== 0) {
        throw new Error('The provided hex string has an odd length. It must have an even length.');
    }
    return Buffer.from(hexString.split('0x')[1], 'hex');
}
export function hexToString(hexString) {
    const asBuffer = hexToBuffer(hexString);
    return asBuffer.toString('utf8');
}
export function getAddressForFormat(address, ss58Format) {
    if (typeof ss58Format === 'string') {
        ss58Format = parseInt(ss58Format, 10);
    }
    try {
        const keyring = new Keyring();
        const encodedAddress = keyring.encodeAddress(address, ss58Format);
        return encodedAddress;
    }
    catch (error) {
        console.error(`Error encoding address ${address}: ${error}`);
        return address;
    }
}
export function encodeSubmittableExtrinsic(extrinsic) {
    return extrinsic.toHex();
}
export function decodeSubmittableExtrinsic(encodedExtrinsic, api) {
    return api.tx(encodedExtrinsic);
}
